import Vue from "vue"
import App from "./App.vue"

import store from "./store"
import vuetify from "./plugins/vuetify"
import router from "./plugins/router"
import i18n from "./plugins/i18n"

import "./plugins/veevalidate"
import "./plugins/moment"
import "./plugins/transitions"
import "./plugins/components"
import "./plugins/filters"

import SecureLS from "secure-ls"
import axios from "./plugins/axios"
import VueClipboard from "vue-clipboard2"
import CKEditor from "@ckeditor/ckeditor5-vue2"
import "ckeditor5-build-custom/build/translations/fr"

Vue.use(VueClipboard)
Vue.use(CKEditor)

Vue.prototype.$mobilecheck = () => {
  let width = window.screen.width
  // Limite based on media queries
  return width > 320 && width < 490
}

Vue.prototype.$ls = new SecureLS({ isCompression: false })

Vue.prototype.$axios = axios

Vue.prototype.$const = {}

Vue.config.productionTip = false

// Configure token header
const token = store.state.auth.token
if (token) {
  axios.defaults.headers.common.Authorization = token
}

axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  function(error) {
    // Do something with response error
    if (error.response.status === 401) {
      window.location = "/login"
    }
    return Promise.reject(error)
  }
)

new Vue({
  store,
  vuetify,
  router,
  i18n,
  render: h => h(App),
}).$mount("#app")
